import { useCallback } from 'react';
import type { PersistentDebugLogger } from '@/hooks/telemetry/use-persistent-debug-logger';
import {
  MobileModalDebugEvent,
  captureMobileModalEnvironment,
} from '@/hooks/telemetry/mobile-modal-debug';

interface UseCstretchmodalCloseHandlerInput {
  debugContext?: Record<string, unknown>;
  debugLogger: PersistentDebugLogger;
  debugName?: string;
  onClose?: () => void;
  visible: boolean;
}

export function useCstretchmodalCloseHandler({
  debugContext,
  debugLogger,
  debugName,
  onClose,
  visible,
}: UseCstretchmodalCloseHandlerInput): () => void {
  return useCallback((): void => {
    if (debugName) {
      debugLogger.logEventFlow({
        name: MobileModalDebugEvent.StretchModalCloseRequested,
        payload: {
          debugName,
          visible,
          debugContext: debugContext ?? null,
          environment: captureMobileModalEnvironment(),
        },
      });
    }
    onClose?.();
  }, [debugContext, debugLogger, debugName, onClose, visible]);
}
